import { useState as u, useCallback as c, useEffect as f } from "react";
function d(e) {
  return "isVisible" in e && e.isVisible !== void 0;
}
const V = {
  info: "status",
  success: "status",
  warning: "alert",
  error: "alert",
  global: "banner"
}, m = {
  info: "polite",
  success: "polite",
  warning: "assertive",
  error: "assertive",
  global: "off"
};
function g({
  onDismiss: e,
  variant: r = "info",
  dismissAriaLabel: n = "Dismiss",
  ...i
} = {}) {
  const s = d(i), [a, t] = u(() => s ? i.isVisible : i.defaultVisible ?? !0), l = c(() => {
    a && (e?.(), s || t(!1));
  }, [a, s, e]);
  f(() => {
    s && i.isVisible !== a && t(i.isVisible);
  }, [i.isVisible, a, s]);
  const b = V[r], o = m[r];
  return {
    bannerProps: {
      role: b,
      "aria-label": i["aria-label"],
      "aria-labelledby": i["aria-labelledby"],
      "aria-describedby": i["aria-describedby"],
      "aria-live": o,
      "aria-atomic": !0
    },
    dismissButtonProps: {
      "aria-label": n,
      onPress: l
    },
    state: {
      isVisible: a
    },
    dismiss: l
  };
}
export {
  g as useBanner
};
//# sourceMappingURL=useBanner.js.map
